import { Link } from "react-router-dom";
import { Truck, PackageCheck, MapPin, Clock3, HelpCircle } from "lucide-react";

const TIERS = [
  { name: "Standard Delivery", time: "3–5 business days", charge: "Free on orders above ₹999 · ₹79 below that", note: "Available across serviceable pincodes in India" },
  { name: "Express Delivery", time: "1–2 business days", charge: "₹99", note: "Available in most metro and major cities" },
  { name: "Same Day Delivery", time: "Same day (order before 6 PM)", charge: "₹149", note: "Currently available in Delhi, Mumbai and Bengaluru pincodes only" },
];

const FAQS = [
  ["How do I know if my pincode is serviceable?", "Enter your pincode on any product page or during checkout — we instantly show available delivery options and dates for your area."],
  ["Do personalized products take longer?", "Personalized gifts need 1–2 extra working days for printing and quality checks before dispatch. The estimated date you see at checkout already includes this."],
  ["Can I change my delivery address after ordering?", "Yes, if the order hasn't shipped yet. Contact us at customizegiftonline@gmail.com or call 9899534126 with your Order ID."],
  ["What if my gift arrives damaged?", "Share a photo within 24 hours of delivery and we'll arrange a replacement or refund — no lengthy forms."],
];

export default function ShippingPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-12 lg:py-16" data-testid="shipping-page">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B45309]">Customer Support</p>
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-stone-900 mt-3 tracking-tight">Shipping & Delivery</h1>
      <p className="text-stone-500 mt-2 max-w-xl">Everything about how your gifts travel — timelines, charges and coverage. <span className="text-xs">(Editable placeholder content — update with final business terms.)</span></p>

      <div className="space-y-4 mt-10">
        {TIERS.map((t) => (
          <div key={t.name} className="flex flex-col sm:flex-row sm:items-center gap-4 p-6 rounded-2xl bg-white border border-[#E9E2D7]" data-testid={`shipping-tier-${t.name.toLowerCase().replace(/\s+/g, "-")}`}>
            <span className="w-11 h-11 rounded-xl bg-[#F5EFE6] grid place-items-center shrink-0"><Truck size={19} className="text-[#B45309]" /></span>
            <div className="flex-1">
              <p className="font-bold text-stone-800">{t.name}</p>
              <p className="text-sm text-stone-500 mt-0.5">{t.note}</p>
            </div>
            <div className="sm:text-right">
              <p className="text-sm font-bold text-stone-900 flex items-center gap-1.5 sm:justify-end"><Clock3 size={13} className="text-[#B45309]" /> {t.time}</p>
              <p className="text-xs text-stone-500 mt-0.5">{t.charge}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
        <div className="p-6 rounded-2xl bg-[#F9F3EA] border border-[#E9E2D7]">
          <MapPin size={18} className="text-[#B45309]" />
          <h3 className="font-serif text-lg font-bold text-stone-900 mt-3">Coverage areas</h3>
          <p className="text-sm text-stone-600 mt-2 leading-relaxed">We ship across India to all valid serviceable pincodes. Same-day delivery is currently limited to select Delhi, Mumbai and Bengaluru pincodes. Check your pincode on any product page for exact options.</p>
        </div>
        <div className="p-6 rounded-2xl bg-[#F9F3EA] border border-[#E9E2D7]">
          <PackageCheck size={18} className="text-[#B45309]" />
          <h3 className="font-serif text-lg font-bold text-stone-900 mt-3">Packed with care</h3>
          <p className="text-sm text-stone-600 mt-2 leading-relaxed">Every gift is quality-checked, wrapped and cushioned for transit. Fragile personalized items get double-layer protective packaging.</p>
        </div>
      </div>

      <h2 className="font-serif text-2xl font-bold text-stone-900 mt-12 mb-5 flex items-center gap-2"><HelpCircle size={20} className="text-[#B45309]" /> Delivery FAQs</h2>
      <div className="space-y-3">
        {FAQS.map(([q, a]) => (
          <div key={q} className="p-5 rounded-2xl bg-white border border-[#E9E2D7]">
            <p className="font-bold text-stone-800 text-sm">{q}</p>
            <p className="text-sm text-stone-500 mt-1.5 leading-relaxed">{a}</p>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-3 mt-10">
        <Link to="/track-order" className="px-6 h-11 rounded-full bg-[#B45309] text-white text-sm font-bold grid place-items-center hover:bg-[#92400E] transition-colors" data-testid="shipping-track-cta">Track Your Order</Link>
        <Link to="/contact" className="px-6 h-11 rounded-full border-2 border-stone-900 text-stone-900 text-sm font-bold grid place-items-center hover:bg-stone-900 hover:text-white transition-colors" data-testid="shipping-contact-cta">Contact Us</Link>
      </div>
    </div>
  );
}
